<template>
    <DefaultTemplate>
        <div class="card rounded signup text-center">
            <h2>จัดการข้อมูลผู้ใช้</h2>
            <!-- <div
                class="has-text-centered pd-y-1 disable-print"
                :class="maxWidth > 768 ? 'pd-y-1' : 'pd-y-3'"
                >
                <b-button
                    :style="styleObject"
                    size="is-medium"
                    icon-pack="fas"
                    icon-left="plus"
                    @click="$router.push('/add-user')"
                    >เพิ่มผู้ใช้งาน</b-button
                >
            </div> -->
            <b-table
                :data="userList"
                :striped="true"
                :hoverable="true"
                :loading="isLoading"
            >
                <template slot-scope="props">
                    <b-table-column field="name" label="ชื่อ-นามสกุล" centered sortable>
                        <div class="has-text-left">
                            <i :class="props.row.activeEmail == 0 ? 'has-text-grey-light' : 'has-text-primary' " class="fas fa-check-circle is-inline-block mg-r-3 mg-l-2"></i>
                            <p class="text-left is-inline-block">{{ props.row.name }} {{ props.row.surname }}</p>
                        </div>
                    </b-table-column>
                    <b-table-column field="email" label="อีเมล" centered sortable>
                        {{ props.row.email }}
                    </b-table-column>
                    <b-table-column field="department" label="หน่วยงาน" centered sortable>
                        {{ props.row.department }}
                    </b-table-column>
                    <b-table-column field="position" label="ตำแหน่ง" centered sortable>
                        {{ props.row.position }}
                    </b-table-column>
                    <b-table-column label="" centered sortable>
                        <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
                            <div slot="trigger">
                                <i class="fas fa-ellipsis-v cr-pointer"></i>
                            </div>
                            <b-dropdown-item aria-role="listitem"><router-link class="d-block" :to="`/edit-user/${props.row._id}`">แก้ไข</router-link></b-dropdown-item>
                            <b-dropdown-item aria-role="listitem">
                                <div @click="confirmCustom(props.row)"> 
                                    ลบ
                                </div>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-table-column>
                </template>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon
                                    icon="emoticon-sad"
                                    size="is-large">
                                </b-icon>
                            </p>
                            <p>ขณะนี้ยังไม่มีข้อมูล</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </DefaultTemplate>
</template>
<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import { HTTP } from "@/service/axios.js";
export default {
    components:{
        DefaultTemplate
    },
    data(){
        return{
            isLoading:true,
            userList:[]
        }
    },
    mounted(){
        this.fetchStaff()
    },
    methods:{
        confirmCustom(user) {
            this.$buefy.dialog.confirm({
                title: 'ลบผู้ใช้งาน',
                message: `คุณต้องการลบ ผู้ใช้งานหรือไม่ ?`,
                cancelText: 'ยกเลิก',
                confirmText: 'ลบ',
                type: 'is-success',
                onConfirm: () => {
                    HTTP.delete(`user/${user._id}`).then(res =>{
                        if(res.data.success){
                            this.fetchStaff()
                        }
                    })
                }
            })
        },
        async fetchStaff(){
            HTTP.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
            let res = await HTTP.get(`all/users/1/all`)
            console.log('res',res);
            if(res.data.success){
                this.isLoading = false
                this.userList = res.data.obj
            }else{
                this.isLoading = false
            }
        }
    }
}
</script>